import type { EChessTeam, IChessPiece } from './chessPieces'
import { chessPieces } from './chessPieces-sidecar'
import { chessPiecesUtil } from './chessPiecesUtil-sidecar'
import { chessTilemap } from './chessTilemap-sidecar'
import type { IChessTilemapPart } from './chessTilemapPart'

export const checkLine = (obj: IChessPiece, tp: IChessTilemapPart) => {
  let dy2 = tp.j - obj.j
  let dx2 = tp.i - obj.i

  let ox = 0
  let oy = 0
  if (dy2 > 0) {
    oy = 1
  }
  if (dy2 < 0) {
    oy = -1
  }
  if (dx2 > 0) {
    ox = 1
  }
  if (dx2 < 0) {
    ox = -1
  }

  let i = obj.i
  let j = obj.j

  let hitOtherTeam = false
  for (let idx = 0; idx < 8; idx++) {
    i += ox
    j += oy

    if (hitOtherTeam) {
      return false
    }

    let t = chessTilemap.getSafe(i, j)
    if (!t) {
      return false
    }
    let valid = true

    for (let iPiece = 0; iPiece < t.pieces.length; iPiece++) {
      let c = t.pieces[iPiece]

      if (c.team === obj.team) {
        return false
      } else {
        if (hitOtherTeam) {
          return false
        }
        hitOtherTeam = true
      }
    }

    if (t === tp) {
      return true
    }
  }
  return true
}

export function isInCheck(obj: IChessPiece): boolean {
  if (obj.isDead) {
    return false
  }
  if (!obj.tile) {
    return false
  }
  let pieces = chessPieces.getAll()
  for (let iPiece = 0; iPiece < pieces.length; iPiece++) {
    let c = pieces[iPiece]
    if (c.isDead) {
      continue
    }
    if (c.team === obj.team) {
      continue
    }
    if (c === obj) {
      continue
    }

    if (chessTilemap.canMove(c, obj.tile, false)) {
      return true
    }
  }

  return false
}

export function isSafeSpotFor(
  tile: IChessTilemapPart,
  team: EChessTeam,
): boolean {
  let pieces = chessPieces.getAll()
  for (let iPiece = 0; iPiece < pieces.length; iPiece++) {
    let c = pieces[iPiece]
    if (c.isDead) {
      continue
    }
    if (c.team === team) {
      continue
    }
    if (chessTilemap.canMove(c, tile, false)) {
      return false
    }
  }
  return true
}
